/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ExternalProfessional/view.blocks to change it.
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function ExternalProfessional({
  children,
  viewPath = "/App/ChooseUser/Users/Content/User/Tag/ExternalProfessional"
  
}) {
  return (<React.Fragment
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 text="External professional"
/>
)}
</TysiaTag>
{children}
</React.Fragment>)
}